
import { throwError as observableThrowError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

@Injectable()
export class ProductService {
    constructor(private http: Http) { }

    getProducts(country: string, provState: string, customerId: string, type: string, size: number): Observable<any> {
        let url = `${environment.api.serviceurl}` + "GetProducts?country" + country + "&provstate=" + provState + "&customerid=" + customerId + "&type=" + type + "&size=" + size;;
        return this.http.get(url).pipe(
            map((response: Response) => {

                let proData = response.json();
                let t = proData.GetProductsResult;
                let p = ('(' + t + ')');
                let s = eval(p);
                return s;
            }));
    }
    
    getXplorerReq(country: string) {
        let url = `${environment.api.serviceurl}` + "GetXplorerReq?country=" + country;;
        return this.http.get(url).pipe(
            map((response: Response) => {

                let proData = response.json();
                let t = proData.getXplorerReqResult;
                let p = ('(' + t + ')');
                let s = eval(p);
                return s;
            }));
    }

    getxplorerReq(customerId: string, companyId: string, country: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getXplorerReq";
        let orderData = { "customerid": customerId, "companyid": companyId, "stringData": country };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    getproducts(country: string, provState: string, customerId: string, type: string, size: number, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getProducts";
        let orderData = { "country": country, "provstate": provState, "customerid": customerId, "type": type, "size": size };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    getbuffer(customerId: string, geoArray: string, radiusNo: string, radiusUnit: string, radiusType: string, geoType: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getBuffer";
        let orderData = { "customerid": customerId, "geoArray": geoArray, "radiusNo": radiusNo, "radiusUnit": radiusUnit, "radiusType": radiusType, "geoType": geoType };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    private extractData(res: Response) {
        let body = res.json();
        if (body.status == "OK") {
            let jsonbody = JSON.parse(body.orderid);
            return jsonbody || {};
        } else {
            observableThrowError(body.message);
            return []
        }
    }

    private handleError(error: any) {
        let errMsg = '';
        if (error.message) {
            errMsg = error.message;
        } else {
            errMsg = error.status ? '${error.status} - ${error.statusText}' : 'Server error';
        }
        return observableThrowError(errMsg);
    }
}